module.exports = __webpack_public_path__ + "static/case_01-8be588ace181db5cf9964243314091a5.jpg";